module.exports = '4.7.0';



// WEBPACK FOOTER //
// ./src/version.js